import { Dispatch } from 'redux';
import { ChangePasswordPageState } from '../../interfaces/ChangePasswordPageState';
import { setIsModalOpened } from '../../ChangePasswordPage.actions';

/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
export function onError(errors: any[], dispatch: Dispatch, setRules: (rules: ChangePasswordPageState) => void, rules: ChangePasswordPageState): void {
  const messages: string[] = [];
  for (let i = 0; i < errors.length; i++) {
    let ErrorCode: string = errors[i].Code;
    /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
    if (ErrorCode === 'ERR_IB_Invalid_StateToken') {
      dispatch(setIsModalOpened(true));
      return;
    }
    if (ErrorCode === 'ERR_IB_PWD_SameAsPersonnalizedCode') {
      ErrorCode = 'ERR_IB_PWD_SameAsUsername';
    }

    messages.push(ErrorCode);
  }

  if (messages.length > 0) {
    setRules({ ...rules, ErrorMessageText: messages });
  }
}
